import { call, put, takeLatest, select } from "redux-saga/effects";
import history from "services/history";
import api from "services/api";
import { raizApi } from "services/raiz-api";

import { ReduxAction } from "store";
import { Creators as alertActions } from "store/ducks/alert";
import { Creators as courseActions, ICourseState } from "store/ducks/course";
import { Creators as qrCodeActions, Types } from "store/ducks/qrCode";
import { IReduxStore } from "interfaces/IReduxStore";
import { theme } from "config/theme";

export function* getQrCode(action: ReduxAction<{ slug: string }>) {
    try {
        const { slug } = action.payload;

        if (theme.project.slug === "proraiz") {
            const { token } = yield select((state: IReduxStore) => state.auth);

            let formattedSlug;

            if (slug.includes("/lo?id=")) {
                formattedSlug = slug.split("/lo?id=")[1];
            } else {
                const parts = slug.split("/");
                formattedSlug = parts[parts.length - 1];
            }

            const { data } = yield call(raizApi.get, `/resolve/${formattedSlug}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (data) {
                const { courses } = yield select((state: IReduxStore) => state.credentials);
                const pathSplitted = data.path.split("/");
                const courseIndex = pathSplitted.findIndex((path: string) => path === "curso");
                const course = courses.find((course: ICourseState) => course.slug === pathSplitted[courseIndex + 1]);

                if (!course) {
                    yield put(alertActions.showAlert("Usuário não tem acesso ao conteúdo relacionado ao QR Code.", "danger"));
                    yield put(qrCodeActions.getQrCodeFailure());
                    return;
                }

                yield put(qrCodeActions.getQrCodeFailure());
                yield put(courseActions.setCourse({ course, shouldPreventRedirect: true }));
                yield call(history.replace, data.path);
            }

            return;
        }

        const courseSlug = yield select((state: IReduxStore) => state.course.slug);
        const { data } = yield call(api.get, `/student/qrcode-v2/${slug}`);

        yield put(qrCodeActions.getQrCodeSuccess(data));

        if (data) {
            yield call(history.push, `/app/curso/${courseSlug}/qr-code/${slug}`);
        }
    } catch (error) {
        yield put(qrCodeActions.getQrCodeFailure());
        yield put(alertActions.showAlert("Por favor verifique o QRCode e tente novamente.", "danger"));
    }
}

export function* getQrCodeExerciseList(action: ReduxAction<{ exerciseListId: string }>) {
    try {
        const { exerciseListId } = action.payload;

        const { data } = yield call(api.get, `/exerciselist/qrcode/${exerciseListId}`, {
            headers: {
                "X-Platform": "mobile"
            }
        });

        yield put(qrCodeActions.getQrCodeExerciseListSuccess(data));
    } catch (error) {
        yield put(qrCodeActions.getQrCodeFailure());
        yield put(alertActions.showAlert("Não foi possível carregar lista de exercícios. Tente novamente.", "danger"));
    }
}

export default [takeLatest(Types.GET_QR_CODE_REQUEST, getQrCode), takeLatest(Types.GET_QR_CODE_EXERCISE_LIST_REQUEST, getQrCodeExerciseList)];
